import React, { useMemo, useRef, useState, useCallback,useEffect } from "react";
import { Canvas, useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import * as THREE from "three";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader";
import { STLExporter } from "three/examples/jsm/exporters/STLExporter";
import { CSG } from "three-csg-ts";
import { mergeVertices, mergeBufferGeometries } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import ClipperLib from "clipper-lib";
import Lottie from "react-lottie-player";
import * as martinez from "martinez-polygon-clipping";
//import martinez from "martinez-polygon-clipping";

import { SimplifyModifier } from "three/examples/jsm/modifiers/SimplifyModifier.js";
import { motion } from "framer-motion";


import lineasblancasvolando from './assets/lottie/lineasblancasvolando.json';
import efectoparticulas from './assets/lottie/efectoparticulas.json';
import fuegorojo from './assets/lottie/fuegorojo.json';
import fuegoamarillo from './assets/lottie/fuegoamarillo.json';
import neutron from './assets/lottie/neutron.json';
import ondacircular from './assets/lottie/ondacircular.json';
import rayoazul from './assets/lottie/rayoazul.json';

import { getDatabase, ref, get } from "firebase/database";
import app from "../../../firebaseConfig";

const db = getDatabase(app);

// Solo nombres (sin importar los JSON)
const nombresFuentes = [
  "Super Vanilla",
  //"Spooky Cartoon",
  "Kind Daily",
  "Candy Beans",
  "The Last Shuriken",
  "Transformers Movie",
  "Zombie Zone",
  "Toasty Milk",
  //"Karate",
  "Simply Rounded",
  "Halo Dek",
  //"Sunday Midnight",
  //"Lovely Heart",
  //"Meow in Love",
  //"Maximum Voltage",
  //"Maximum Voltage Italic",
  //"Vampire Wars",
  //"Vampire Wars Italic",
  "Gimbot",
  //"Billy Bounce",
  //"BlackCastleMF",
  //"Candy Shop",
  //"Candy Shop Black",
  "AngryBirds",
  "Tomcat",
  "Comicoon",
  //"Grinched",
  //"Kraash",
  //"Kraash Black",
  //"Powerful",
  "Milky Nice",
  "Milky Nice Clean",
  //"Super Mario 256",
  "Dinosaur",
  //"Sealight Whisper",
  "Yourmate",
  "BubbleGum",
  //"Magic Sound",
  "Bestime",
  "Super Boys",
  //"Milkshake Creps",
  //"GrindAndDeath",
  //"God Of War",
  //"Dynamix",
];


export default function GeneradorLampara2D() {
  const [nombre, setNombre] = useState("MARIA");
  const [size, setSize] = useState(42);
  const [contornoDistancia, setContornoDistancia] = useState(3);
  const [bordeNegroDistancia, setBordeNegroDistancia] = useState(-2.5);

  const [fuenteTemporal, setFuenteTemporal] = useState("Gimbot"); // seleccionada en el menú
  const [fuenteSeleccionada, setFuenteSeleccionada] = useState("Gimbot"); // aplicada realmente

  const [espaciado, setEspaciado] = useState(-1);


  // UI agujeros
  const [agregarAgujeros, setAgregarAgujeros] = useState(true);
  const [rects, setRects] = useState([]); // {id,x,y,w,h}
  const [selectedId, setSelectedId] = useState(null);
  // junto a los otros useState (por ejemplo near size, contornoDistancia, etc.)
const [zoom, setZoom] = useState(1.3); // zoom para la previsualización (no afecta el STL)

///////////////////////////////////////////////////////////
// Estado para puntillas
const [pins, setPins] = useState([]);
const [selectedPinId, setSelectedPinId] = useState(null);
// Radio de la puntilla (mm). Cabeza 5mm -> radio 2.5 mm
const PIN_RADIUS_MM = 2.5;
///////////////////////////////////////////////////////////



  const precisionEscala = 100;

  const BASE_DEPTH = 60; // tu sólido total
  const BASE_CUT = 55; // tu sólido total CORTE
  
  // ======== CANAL INTERNO (tubería) ========
  const WALL_THICKNESS_TOP_BOTTOM = 2; // deja piel arriba y abajo
  const CHANNEL_Z = 11;
  const CHANNEL_DEPTH = 12; // 16mm

  // Parámetro del ancho del delineado naranja (en unidades de fuente)
  const orangeStrokeDist = 3;
  const ORANGE_DEPTH = 50; // <- poner 16 si prefieres 16mm en lugar de 13
  const bordeblancoalto = 50; // <- poner 16 si prefieres 16mm en lugar de 13

  const CURVE_SEGMENTS = 1;
  const SAMPLE_POINTS = 6;

// ======== PARÁMETROS DE LA LÁMPARA ========
const [profundidadBase, setProfundidadBase] = useState(20);  // BASE_DEPTH
const [espesorPared, setEspesorPared] = useState(2);         // WALL_THICKNESS_TOP_BOTTOM
const [alturaCanal, setAlturaCanal] = useState(6);           // CHANNEL_Z
const [profundidadCanal, setProfundidadCanal] = useState(5); // CHANNEL_DEPTH

const [grosorAnilloNaranja, setGrosorAnilloNaranja] = useState(1.6); // orangeStrokeDist
const [profundidadAnilloNaranja, setProfundidadAnilloNaranja] = useState(11); // ORANGE_DEPTH

// -> ADD (near other useState)
const [appliedSettings, setAppliedSettings] = useState(null);

const [fontData, setFontData] = useState(null);

// ===== Overlay de carga =====
const [isLoading, setIsLoading] = useState(true); // comienza cargando
const [progress, setProgress] = useState(0);
const [showWarning, setShowWarning] = useState(false);

const [animacionSeleccionada, setAnimacionSeleccionada] = useState(null);

// 🧩 Estado para los precios
const [precios, setPrecios] = useState({ Mini: 0, Mediano: 0, Grande: 0 });
const [tamanoSeleccionado, setTamanoSeleccionado] = useState("Mini");
const [costoLetra, setCostoLetra] = useState(0);


  // Arreglo de animaciones disponibles
  const animacionesDisponibles = [
    lineasblancasvolando,
    efectoparticulas,
    fuegoamarillo,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    rayoazul,
    neutron,
    ondacircular,
    ondacircular,
    ondacircular,
    ondacircular,
    ondacircular,
    ondacircular,
    fuegorojo,
    fuegoamarillo,
  ];




// Detecta si hay cambios respecto a lo aplicado
const isModified = useMemo(() => {
  if (!appliedSettings) return false;
  return (
    nombre !== appliedSettings.nombre ||
    fuenteTemporal !== appliedSettings.fuenteSeleccionada
  );
}, [nombre, fuenteTemporal, appliedSettings]);

  // === Fuente ===
  const font = useMemo(() => (fontData ? new FontLoader().parse(fontData) : null), [fontData]);

  // Nuevo: todas azul claro excepto la última en rojo
const defaultColor = "#7EC8FF";  // azul claro
const lastColor = "#FF0000";     // rojo



////------------------------------------------------------------------------------
///------------------------------------------------------------------------------
  const fuentesCache = useRef({});

  useEffect(() => {
    if (!fuenteSeleccionada) return;
  
    async function loadFont() {
      if (fuentesCache.current[fuenteSeleccionada]) {
        // ya estaba cargada previamente
        setFontData(fuentesCache.current[fuenteSeleccionada]);
        return;
      }
  

    // Mapeo de nombres a sus imports dinámicos
    const fuentes = {
      "Super Vanilla": () => import("../../../fonts/Super Vanilla_Regular.json"),
      "Spooky Cartoon": () => import("../../../fonts/Spooky Cartoon_Regular.json"),
      "Kind Daily": () => import("../../../fonts/Kind Daily_Regular.json"),
      "Candy Beans": () => import("../../../fonts/Candy Beans_Regular.json"),
      "The Last Shuriken": () => import("../../../fonts/The Last Shuriken_Regular.json"),
      "Transformers Movie": () => import("../../../fonts/Transformers Movie_Regular.json"),
      "Zombie Zone": () => import("../../../fonts/Zombie Zone_Regular.json"),
      "Toasty Milk": () => import("../../../fonts/Toasty Milk_Regular.json"),
      "Karate": () => import("../../../fonts/Karate_Medium.json"),
      "Simply Rounded": () => import("../../../fonts/Simply_Rounded_Bold.json"),
      "Halo Dek": () => import("../../../fonts/Halo Dek_Regular.json"),
      "Sunday Midnight": () => import("../../../fonts/Sunday Midnight_Regular.json"),

      // === NUEVAS FUENTES ===
      "Lovely Heart": () => import("../../../fonts/LOVELY HEART_Regular.json"),
      "Meow in Love": () => import("../../../fonts/Meow in Love Demo_Regular.json"),
      "Maximum Voltage": () => import("../../../fonts/Maximum Voltage_Regular.json"),
      "Maximum Voltage Italic": () => import("../../../fonts/Maximum Voltage_Italic.json"),
      "Vampire Wars": () => import("../../../fonts/Vampire Wars_Regular.json"),
      "Vampire Wars Italic": () => import("../../../fonts/Vampire Wars_Italic.json"),
      "Gimbot": () => import("../../../fonts/Gimbot_Regular.json"),
      "Billy Bounce": () => import("../../../fonts/Billy Bounce_Regular.json"),
      "BlackCastleMF": () => import("../../../fonts/BlackCastleMF_Regular.json"),
      "Candy Shop": () => import("../../../fonts/Candy Shop_Regular.json"),
      "Candy Shop Black": () => import("../../../fonts/Candy Shop Black_Regular.json"),
      "AngryBirds": () => import("../../../fonts/AngryBirds_Regular.json"),
      "Tomcat": () => import("../../../fonts/Tomcat_Regular.json"),
      "Comicoon": () => import("../../../fonts/Comicoon_Regular.json"),
      "Grinched": () => import("../../../fonts/Grinched_Regular.json"),
      "Kraash": () => import("../../../fonts/Kraash_Regular.json"),
      "Kraash Black": () => import("../../../fonts/Kraash Black_Regular.json"),
      "Powerful": () => import("../../../fonts/Powerful_Regular.json"),
      "Milky Nice": () => import("../../../fonts/Milky Nice_Regular.json"),
      "Milky Nice Clean": () => import("../../../fonts/Milky Nice Clean_Regular.json"),
      "Super Mario 256": () => import("../../../fonts/Super Mario 256_Regular.json"),
      "Dinosaur": () => import("../../../fonts/Dinosaur_Regular.json"),
      "Sealight Whisper": () => import("../../../fonts/Sealight Whisper_Regular.json"),
      "Yourmate": () => import("../../../fonts/Yourmate_Regular.json"),
      "BubbleGum": () => import("../../../fonts/BubbleGum_Regular.json"),
      "Magic Sound": () => import("../../../fonts/Magic Sound_Regular.json"),
      "Bestime": () => import("../../../fonts/Bestime_Regular.json"),
      "Super Boys": () => import("../../../fonts/Super Boys_Regular.json"),
      "Milkshake Creps": () => import("../../../fonts/Milkshake Creps_Regular.json"),
      "GrindAndDeath": () => import("../../../fonts/GrindAndDeath_Demo_Regular.json"),
      "God Of War": () => import("../../../fonts/GodOfWar_Regular.json"),
      "Dynamix": () => import("../../../fonts/Dynamix_Regular.json"),
    };
    
    const loader = fuentes[fuenteSeleccionada];
    try {
      if (loader) {
        const mod = await loader();
        fuentesCache.current[fuenteSeleccionada] = mod.default; // ⚡ guardamos en caché
        setFontData(mod.default);
      } else {
        console.warn("⚠️ Fuente no encontrada:", fuenteSeleccionada);
        setFontData(null);
      }
    } catch (error) {
      console.error("❌ Error cargando fuente:", fuenteSeleccionada, error);
      setFontData(null);
    }
  }

  loadFont();
}, [fuenteSeleccionada]);
///------------------------------------------------------------------------------
///------------------------------------------------------------------------------

// -> REPLACE existing initialization (if tienes `useState(letrasData.map(...))`) with:
const [coloresLetras, setColoresLetras] = useState([]);



useEffect(() => {
  try {
    const savedColors = localStorage.getItem("lampara_colores_letras_v1");
    if (savedColors) {
      setColoresLetras(JSON.parse(savedColors));
    }
  } catch (e) {
    console.warn("Error cargando colores de letras:", e);
  }
}, []);




//------------------------------------------------------------------------------------------
//------------------Cargar los precios desde Firebase y la selección guardada---------------------
useEffect(() => {
  const preciosRef = ref(db, "nature/Awoo/Categorias/Nombres Iluminados/Precios");

  get(preciosRef).then((snapshot) => {
    if (snapshot.exists()) {
      const data = snapshot.val();
      setPrecios({
        Mini: data.Mini || 0,
        Mediano: data.Mediano || 0,
        Grande: data.Grande || 0,
      });

      // Recuperar selección guardada o por defecto "Mini"
      const guardado = localStorage.getItem("tamanoSeleccionado") || "Mini";
      setTamanoSeleccionado(guardado);
      setCostoLetra(data[guardado] || data.Mini || 0);
    }
  });
}, []);
const seleccionarTamano = (tam) => {
  setTamanoSeleccionado(tam);
  setCostoLetra(precios[tam]);
  localStorage.setItem("tamanoSeleccionado", tam);
};

// 🔹 Calcular número de letras (ignorando espacios)
const nLetras = nombre.replace(/\s+/g, "").length;
// 🔹 Calcular total (costo por letra * número de letras)
const total = nLetras * costoLetra;
//------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------

///------------------------------------------------------------------------------
////////////////////////////////////
  // Selecciona una animación aleatoria al montar el componente
  useEffect(() => {
    const seleccionAleatoria =
      animacionesDisponibles[
        Math.floor(Math.random() * animacionesDisponibles.length)
      ];
    setAnimacionSeleccionada(seleccionAleatoria);
  }, []);
///------------------------------------------------------------------------------

// -> ADD (run once on mount) Cargar / inicializar ajustes guardados desde localStorage (run on mount)
useEffect(() => {
  try {
    const saved = localStorage.getItem("lampara_settings_v1");
    if (saved) {
      const parsed = JSON.parse(saved);

      // actualizar controles para que el UI muestre la configuración guardada
      if (parsed.nombre !== undefined) setNombre(parsed.nombre);
      if (parsed.size !== undefined) setSize(parsed.size);
      if (parsed.contornoDistancia !== undefined) setContornoDistancia(parsed.contornoDistancia);
      if (parsed.bordeNegroDistancia !== undefined) setBordeNegroDistancia(parsed.bordeNegroDistancia);
      if (parsed.fuenteSeleccionada !== undefined) setFuenteSeleccionada(parsed.fuenteSeleccionada);
      if (parsed.espaciado !== undefined) setEspaciado(parsed.espaciado);

      // aplicar inmediatamente para que letrasData use esta configuración al cargar
      setAppliedSettings(parsed);
    } else {
      // si no hay guardado, inicializamos appliedSettings con los valores por defecto actuales
      setAppliedSettings({
        nombre, size, contornoDistancia, bordeNegroDistancia, fuenteSeleccionada, espaciado
      });
    }
  } catch (e) {
    console.warn("Error cargando settings desde localStorage:", e);
    setAppliedSettings({
      nombre, size, contornoDistancia, bordeNegroDistancia, fuenteSeleccionada, espaciado
    });
  }
}, []); // sólo al montar

//--------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------
// Efecto inicial (al montar el componente)
useEffect(() => {
  simulateProgress();
}, []);

// Función que simula el progreso
function simulateProgress(callback) {
  setIsLoading(true);
  setProgress(0);

  let p = 0;
  const interval = setInterval(() => {
    p += Math.random() * 10; // sube irregularmente para hacerlo más natural
    if (p >= 100) {
      p = 100;
      clearInterval(interval);
      setTimeout(() => {
        setIsLoading(false);
        if (callback) callback();
      }, 300); // una pequeña pausa al 100%
    }
    setProgress(p);
  }, 150);
}
// 🔹 Modifica tu handleGenerate existente:
async function handleGenerate() {
  const payload = {
    nombre,
    size,
    contornoDistancia,
    bordeNegroDistancia,
    fuenteSeleccionada: fuenteTemporal,
    espaciado,
  };

  try {
    // 🧩 Guardar configuración local
    localStorage.setItem("lampara_settings_v1", JSON.stringify(payload));
    setAppliedSettings(payload);
    setFuenteSeleccionada(fuenteTemporal);

    console.log("Configuración aplicada y guardada");

    // 🧩 Paso 1: mostrar overlay inmediatamente
    setIsLoading(true);
    setProgress(0);

    // 🧩 Paso 2: dejar a React renderizar el overlay
    await new Promise(requestAnimationFrame);

    // 🧩 Paso 3: iniciar progreso en el siguiente ciclo
    setTimeout(() => {
      simulateProgress(() => {
        setIsLoading(false);
      });
    }, 0);

  } catch (e) {
    console.error("No se pudo guardar la configuración:", e);
  }
}



  // ===== Aux: área, orientación, shapes de clipper =====
  function polygonArea(points) {
    let a = 0;
    for (let i = 0, l = points.length; i < l; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % l];
      a += p1.X * p2.Y - p2.X * p1.Y;
    }
    return a / 2;
  }
  function clipperToVector2(points, flipIfNegative = true) {
    const arr = points.map((pt) => new THREE.Vector2(pt.X / precisionEscala, pt.Y / precisionEscala));
    const area = polygonArea(points);
    if (flipIfNegative && area < 0) arr.reverse();
    return arr;
  }
  function pointInPolygon(pt, poly) {
    let inside = false;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      const xi = poly[i].X, yi = poly[i].Y;
      const xj = poly[j].X, yj = poly[j].Y;
      const intersect = (yi > pt.Y) !== (yj > pt.Y) && pt.X < ((xj - xi) * (pt.Y - yi)) / (yj - yi + 0.0) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }
  function makeShapesFromOffsetPaths(offsetPaths) {
    if (!offsetPaths || offsetPaths.length === 0) return [];
    try {
      if (ClipperLib.Clipper && ClipperLib.Clipper.SimplifyPolygons) {
        offsetPaths = ClipperLib.Clipper.SimplifyPolygons(offsetPaths, ClipperLib.PolyFillType.pftNonZero);
      }
    } catch {}
    const polys = offsetPaths.map((p) => ({ pts: p, area: Math.abs(polygonArea(p)) })).sort((a, b) => b.area - a.area);
    const used = new Array(polys.length).fill(false);
    const shapes = [];
    for (let i = 0; i < polys.length; i++) {
      if (used[i]) continue;
      const exterior = polys[i].pts;
      used[i] = true;
      const shape = new THREE.Shape(clipperToVector2(exterior, true));
      for (let j = i + 1; j < polys.length; j++) {
        if (used[j]) continue;
        const testPt = polys[j].pts[Math.floor(polys[j].pts.length / 2)];
        if (pointInPolygon(testPt, exterior)) {
          const holeVecs = clipperToVector2(polys[j].pts, true);
          shape.holes.push(new THREE.Path(holeVecs));
          used[j] = true;
        }
      }
      shapes.push(shape);
    }
    return shapes;
  }
  function CameraZoomController({ zoom }) {
    const { camera } = useThree();
    useEffect(() => {
      if (!camera) return;
      camera.zoom = zoom;
      camera.updateProjectionMatrix();
    }, [zoom, camera]);
    return null;
  }

  // ------------ HELPERS Clipper <-> Three -------------
  function shapeToClipperPaths(shape, precision, translateX = 0, translateY = 0) {
    const paths = [];
    const outer = shape.getPoints(SAMPLE_POINTS).map((p) => ({
      X: Math.round((p.x + translateX) * precision),
      Y: Math.round((p.y + translateY) * precision),
    }));
    if (outer.length > 0) paths.push(outer);

    shape.holes.forEach((hole) => {
      const holePts = hole.getPoints(SAMPLE_POINTS).map((p) => ({
        X: Math.round((p.x + translateX) * precision),
        Y: Math.round((p.y + translateY) * precision),
      }));
      if (holePts.length > 0) paths.push(holePts);
    });
    return paths;
  }
function clipperPathsToThreeShapes(paths, precision) {
  const polyPoints = paths.map((p) => p.map((pt) => new THREE.Vector2(pt.X / precision, pt.Y / precision)));

  const polygonArea = (pts) => {
    let a = 0;
    for (let i = 0; i < pts.length; i++) {
      const p1 = pts[i];
      const p2 = pts[(i + 1) % pts.length];
      a += p1.x * p2.y - p2.x * p1.y;
    }
    return a / 2;
  };

  const pointInPoly = (pt, poly) => {
    let inside = false;
    for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      const xi = poly[i].x, yi = poly[i].y;
      const xj = poly[j].x, yj = poly[j].y;
      const intersect = ((yi > pt.y) !== (yj > pt.y)) &&
        (pt.x < (xj - xi) * (pt.y - yi) / (yj - yi + 0.0000001) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  };

  let outers = [];
  let holes = [];
  polyPoints.forEach((pts) => {
    const a = polygonArea(pts);
    if (a > 0) outers.push({ pts, area: a });
    else holes.push({ pts, area: a });
  });

  if (outers.length === 0 && holes.length > 0) {
    outers = holes.map(h => ({ pts: h.pts, area: -h.area }));
    holes = [];
  }

  const shapes = outers.map(o => ({ outer: o.pts, holes: [] }));
  holes.forEach((h) => {
    let attached = false;
    for (let s of shapes) {
      if (pointInPoly(h.pts[0], s.outer)) {
        s.holes.push(h.pts);
        attached = true;
        break;
      }
    }
    if (!attached) shapes.push({ outer: h.pts, holes: [] });
  });

  const threeShapes = shapes.map((s) => {
    const shape = new THREE.Shape(s.outer);
    s.holes.forEach(h => shape.holes.push(new THREE.Path(h)));
    return shape;
  });

  return threeShapes;
}
// ---------------------------------------------------

// ======= Geometrías de letras =======
const letrasData = useMemo(() => {
  if (!font) return []; // 🔥 Esperar a que la fuente esté cargada
  if (!appliedSettings) return [];

    // extraemos valores que el usuario "aplicó" con el botón Generar
    const {
      nombre: nombreA,
      size: sizeA,
      contornoDistancia: contornoA,
      bordeNegroDistancia: bordeNegroA,
      espaciado: espaciadoA,
      // añade más campos si los guardas
    } = appliedSettings;
  

  // usa nombreA, sizeA, contornoA, bordeNegroA, espaciadoA en vez de los estados directos
  const shapesBase = font.generateShapes(nombreA, sizeA, CURVE_SEGMENTS);
  const geometriaTexto = new THREE.ShapeGeometry(shapesBase);
  geometriaTexto.computeBoundingBox();

  const anchoTotal = geometriaTexto.boundingBox.max.x - geometriaTexto.boundingBox.min.x;
  const altoTotal = geometriaTexto.boundingBox.max.y - geometriaTexto.boundingBox.min.y;

  let offsetX = -anchoTotal / 2;
  const lettersInfo = [];
  

  // --- PRIMER PASO: info base por letra ---
  for (let i = 0; i < nombreA.length; i++) {
    const letra = nombreA[i];
    const shapesLetra = font.generateShapes(letra, sizeA, CURVE_SEGMENTS);
    const geomLetra = new THREE.ShapeGeometry(shapesLetra);
    geomLetra.computeBoundingBox();

    const anchoLetra = geomLetra.boundingBox.max.x - geomLetra.boundingBox.min.x;
    geomLetra.translate(-anchoLetra / 2, -altoTotal / 2, 0);

    const basePaths = [];
    shapesLetra.forEach((shape) => {
      const paths = shapeToClipperPaths(shape, precisionEscala, 0, 0);
      paths.forEach(p => basePaths.push(p));
    });

    const posX = offsetX + anchoLetra / 2;

    lettersInfo.push({
      letra,
      shapesLetra,
      geomLetra,
      anchoLetra,
      offsetX,
      posX,
      basePaths,
    });

    offsetX += anchoLetra + espaciadoA;
  }

  // --- helper para separar outer / holes ---
  function separateOutersAndHoles(paths) {
    const areas = paths.map(p => {
      let a = 0;
      for (let i = 0; i < p.length; i++) {
        const p1 = p[i];
        const p2 = p[(i + 1) % p.length];
        a += p1.X * p2.Y - p2.X * p1.Y;
      }
      return a / 2;
    });

    const outers = [];
    const holes = [];
    paths.forEach((p, i) => {
      if (areas[i] > 0) outers.push(p); // exterior
      else holes.push(p);              // agujero
    });

    return { outers, holes };
  }

  // --- SEGUNDO PASO: geometrías con contorno, negro, blanco recortado y anillo naranja ---
  const letras = [];
  const contornoRawByIndex = [];

  for (let i = 0; i < lettersInfo.length; i++) {
    const info = lettersInfo[i];

    // separa contornos y agujeros de ESTA letra
    const { outers, holes } = separateOutersAndHoles(info.basePaths);
    const offsetPaths = [];

    const co = new ClipperLib.ClipperOffset(); 
    co.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon); 
    co.Execute(offsetPaths, contornoA * precisionEscala); 
    const offsetPathsRaw = offsetPaths.map(p => p.map(pt => ({ X: pt.X, Y: pt.Y }))); contornoRawByIndex[i] = offsetPathsRaw; 
    const contornoShapesThree = clipperPathsToThreeShapes(offsetPaths, precisionEscala); 
    const geomContorno = contornoShapesThree.length > 0 ? new THREE.ShapeGeometry(contornoShapesThree) : new THREE.ShapeGeometry([]); geomContorno.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);


    // borde negro (inset)
    const co2 = new ClipperLib.ClipperOffset();
    co2.AddPaths(info.basePaths, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
    const offsetPaths2 = [];
    co2.Execute(offsetPaths2, bordeNegroA * precisionEscala);

    // prev contornos desplazados + prev base para recortar blanco
    const prevContornoShifted = [];
    const prevBaseShifted = [];
    for (let j = 0; j < i; j++) {
      const prevInfo = lettersInfo[j];
      const deltaXprev = Math.round((prevInfo.offsetX - info.offsetX) * precisionEscala);

      const prevRaw = contornoRawByIndex[j];
      if (prevRaw) {
        prevRaw.forEach((p) => {
          const shifted = p.map(pt => ({ X: pt.X + deltaXprev, Y: pt.Y }));
          prevContornoShifted.push(shifted);
        });
      }

      if (prevInfo.basePaths) {
        prevInfo.basePaths.forEach((p) => {
          const shiftedBase = p.map(pt => ({ X: pt.X + deltaXprev, Y: pt.Y }));
          prevBaseShifted.push(shiftedBase);
        });
      }
    }

    // recortar blanco (quita negro + letras previas)
    let finalWhitePaths = info.basePaths;
    const combinedClipForWhite = [];
    if (offsetPaths2.length > 0) combinedClipForWhite.push(...offsetPaths2);
    if (prevBaseShifted.length > 0) combinedClipForWhite.push(...prevBaseShifted);

    if (combinedClipForWhite.length > 0 && info.basePaths.length > 0) {
      const cWhite = new ClipperLib.Clipper();
      cWhite.AddPaths(info.basePaths, ClipperLib.PolyType.ptSubject, true);
      cWhite.AddPaths(combinedClipForWhite, ClipperLib.PolyType.ptClip, true);
      const whiteDiff = new ClipperLib.Paths();
      cWhite.Execute(ClipperLib.ClipType.ctDifference, whiteDiff, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
      finalWhitePaths = whiteDiff;
    }

    // anillo naranja
    let orangeRingPaths = [];
    if (prevContornoShifted.length > 0 && info.basePaths.length > 0) {
      const c3 = new ClipperLib.Clipper();
      c3.AddPaths(prevContornoShifted, ClipperLib.PolyType.ptSubject, true);
      c3.AddPaths(info.basePaths, ClipperLib.PolyType.ptClip, true);
      const inter = new ClipperLib.Paths();
      c3.Execute(ClipperLib.ClipType.ctIntersection, inter, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

      if (inter.length > 0) {
        const co3 = new ClipperLib.ClipperOffset();
        co3.AddPaths(inter, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
        const orangeOffsetPaths = [];
        co3.Execute(orangeOffsetPaths, orangeStrokeDist * precisionEscala);

        if (orangeOffsetPaths.length > 0) {
          const c4 = new ClipperLib.Clipper();
          c4.AddPaths(orangeOffsetPaths, ClipperLib.PolyType.ptSubject, true);
          c4.AddPaths(inter, ClipperLib.PolyType.ptClip, true);
          const ring = new ClipperLib.Paths();
          c4.Execute(ClipperLib.ClipType.ctDifference, ring, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
          orangeRingPaths = ring;
        }
      }
    }

    const whiteShapesThree = clipperPathsToThreeShapes(finalWhitePaths, precisionEscala);
    const geomTextoRecortado = whiteShapesThree.length > 0 ? new THREE.ShapeGeometry(whiteShapesThree) : new THREE.ShapeGeometry([]);
    geomTextoRecortado.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    const blackShapesThree = clipperPathsToThreeShapes(offsetPaths2, precisionEscala);
    const geomBordeNegro = blackShapesThree.length > 0 ? new THREE.ShapeGeometry(blackShapesThree) : new THREE.ShapeGeometry([]);
    geomBordeNegro.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    const orangeShapesThree = clipperPathsToThreeShapes(orangeRingPaths, precisionEscala);
    const geomOrangeRing = orangeShapesThree.length > 0 ? new THREE.ShapeGeometry(orangeShapesThree) : new THREE.ShapeGeometry([]);
    geomOrangeRing.translate(-info.anchoLetra / 2, -altoTotal / 2, 0);

    letras.push({
      letra: info.letra,
      posX: info.posX,
      anchoLetra: info.anchoLetra,
      offsetX: info.offsetX,
      altoTotal,
      bordeColor: coloresLetras[i] ?? defaultColor,
      textoGeom: geomTextoRecortado,
      contornoGeom: geomContorno,
      bordeNegroGeom: geomBordeNegro,
      orangeGeom: geomOrangeRing,
      shapesLetra: info.shapesLetra,
      shapesContorno: contornoShapesThree,
      shapesBordeNegro: blackShapesThree,
      shapesNaranja: orangeShapesThree,
    });
  }

  return letras;
}, [font, appliedSettings]);




// -> ADD effect to populate when letrasData cambie (por ejemplo justo después) PARA Colores
useEffect(() => {
  if (!letrasData || letrasData.length === 0) {
    setColoresLetras([]);
    return;
  }

  // 1) Intentar cargar colores guardados EXCEPTO si el nombre cambió
  //const saved = localStorage.getItem("colores_letras_v1");
  //if (saved) {
  //  const parsed = JSON.parse(saved);

    // si el nombre coincide, usamos lo guardado
 //   if (parsed.nombre === appliedSettings.nombre &&
   //     parsed.colores &&
     //   parsed.colores.length === letrasData.length) {
    //  setColoresLetras(parsed.colores);
    //  return;
   // }
 // }

  // 2) Si no hay guardados o cambió el nombre → aplicar colores por defecto
  const nuevosColores = letrasData.map((_, i) =>
    i === letrasData.length - 1 ? lastColor : defaultColor
  );

  setColoresLetras(nuevosColores);
}, [letrasData, appliedSettings?.nombre]);

///------------------------/------------------------------
///------------------------/---Guardar los colores en localStorage cuando cambien---------------------------
useEffect(() => {
  if (coloresLetras.length === 0) return;

  localStorage.setItem(
    "colores_letras_v1",
    JSON.stringify({
      nombre: appliedSettings?.nombre,
      colores: coloresLetras
    })
  );
}, [coloresLetras, appliedSettings?.nombre]);
///------------------------/------------------------------
///------------------------/------------------------------



  // ====== Limpieza de geometrías ======
  function removeDegenerateTriangles(geom, eps = 1e-6) {
    let g = geom.index ? geom.toNonIndexed() : geom.clone();
    const pos = g.getAttribute("position");
    const arr = pos.array;
    const newPos = [];
    for (let i = 0; i < arr.length; i += 9) {
      const ax = arr[i], ay = arr[i + 1], az = arr[i + 2];
      const bx = arr[i + 3], by = arr[i + 4], bz = arr[i + 5];
      const cx = arr[i + 6], cy = arr[i + 7], cz = arr[i + 8];
      const abx = bx - ax, aby = by - ay, abz = bz - az;
      const acx = cx - ax, acy = cy - ay, acz = cz - az;
      const nx = aby * acz - abz * acy;
      const ny = abz * acx - abx * acz;
      const nz = abx * acy - aby * acx;
      const area2 = Math.sqrt(nx * nx + ny * ny + nz * nz);
      if (area2 > eps) newPos.push(ax, ay, az, bx, by, bz, cx, cy, cz);
    }
    const newG = new THREE.BufferGeometry();
    newG.setAttribute("position", new THREE.Float32BufferAttribute(newPos, 3));
    newG.computeVertexNormals();
    return newG;
  }


  const sel = rects.find((r) => r.id === selectedId);





  // --- cerca de donde ya tienes letrasData (justo después de su useMemo) ---
// Precomputar settings y geometrías extruidas (hooks en top-level)
// extrusión principal (4cm = 40mm)
const extrudeSettings = useMemo(() => ({ depth: 40, bevelEnabled: false, curveSegments: CURVE_SEGMENTS }), [CURVE_SEGMENTS]);

// Profundidades auxiliares para detalles:
const whiteDepth = 2;  // capa blanca fina en la superficie (mm)
const blackInsetDepth = 6; // profundidad del hueco negro (mm)

// Calcula las geometrías extruidas aplicando CSG para recortar solapamientos y aplicar huecos/blancos
const extrudedResultByLetter = useMemo(() => {
  // acumulador de union de letras previas (como mesh)
  let prevUnionMesh = null;

  const results = letrasData.map((letra, idx) => {
    try {
      // ---------- 1) extrusión base (contorno coloreado) ----------
      const contShapes = letra.shapesContorno || [];
      if (!contShapes || contShapes.length === 0) return null;

      const baseGeom = new THREE.ExtrudeGeometry(contShapes, extrudeSettings);
      // Centrar la geometría localmente
      baseGeom.translate(-letra.anchoLetra / 2, -letra.altoTotal / 2, 0);
      
      // Convertir a Mesh temporal para CSG
      const baseMesh = new THREE.Mesh(baseGeom, new THREE.MeshStandardMaterial());

      // posiciona la geometría en X (coordenadas del texto)
      baseMesh.position.set(letra.posX * 1.1, 0, 0); // mantuve tu *1.1 en render original
      baseMesh.updateMatrix();

      // ---------- 2) cortar con letras previas ----------
      let finalColoredMesh = baseMesh;
      if (prevUnionMesh) {
        // Asegúrate de actualizar matrices
        finalColoredMesh.updateMatrix();
        prevUnionMesh.updateMatrix();

        // Usamos CSG.subtract: resultado = base - prevUnion
        // (si tu versión de three-csg-ts usa fromMesh / toMesh puedes cambiar a ese patrón)
        try {
          const sub = CSG.subtract(finalColoredMesh, prevUnionMesh);
          // sub ya es un Mesh
          finalColoredMesh = sub;
          finalColoredMesh.geometry.computeVertexNormals();
        } catch (err) {
          console.warn("CSG subtract falló (intentando fallback):", err);
        }
      }

      // ---------- 3) crear corte negro (inset) restando una extrusión poco profunda ----------
// ---------- 3) crear corte negro (inset) restando una extrusión poco profunda ----------
let blackCutMesh = null;
if (letra.shapesBordeNegro && letra.shapesBordeNegro.length > 0) {
  // creamos una extrusión poco profunda (solo la profundidad del inset)
  const blackGeom = new THREE.ExtrudeGeometry(
    letra.shapesBordeNegro,
    { depth: blackInsetDepth, bevelEnabled: false, curveSegments: CURVE_SEGMENTS }
  );
  blackGeom.translate(-letra.anchoLetra / 2, -letra.altoTotal / 2, 0);

  const blackMesh = new THREE.Mesh(blackGeom, new THREE.MeshStandardMaterial());
  // <-- aquí es donde está la diferencia: colocamos el hueco EN LA PARTE SUPERIOR
  const topZ = extrudeSettings.depth - blackInsetDepth - 0.01; // pequeño offset para evitar z-fighting
  blackMesh.position.set(letra.posX * 1.1, 0, topZ);
  blackMesh.updateMatrix();

  // Restar blackMesh (hueco) de finalColoredMesh para que aparezca inset en la superficie
  try {
    const sub2 = CSG.subtract(finalColoredMesh, blackMesh);
    finalColoredMesh = sub2;
    finalColoredMesh.geometry.computeVertexNormals();
  } catch (err) {
    console.warn("CSG subtract (black) falló:", err);
  }
  blackCutMesh = blackMesh;
}


      // ---------- 4) crear la capa blanca (superficie): extruida muy fina y posicionada en la parte superior ----------
      let whiteSurfaceMesh = null;
      if (letra.textoGeom && letra.textoGeom.attributes) {
        // Si tienes shapes de texto (no sólo ShapeGeometry) preferible usar shapes; aquí usamos letra.textoGeom como ShapeGeometry
        // mejor opción: extruir letra.shapesLetra si existe
      }

      if (letra.shapesLetra && letra.shapesLetra.length > 0) {
        const whiteGeom = new THREE.ExtrudeGeometry(letra.shapesLetra, { depth: whiteDepth, bevelEnabled: false, curveSegments: CURVE_SEGMENTS });
        whiteGeom.translate(-letra.anchoLetra / 2, -letra.altoTotal / 2, 0);
        const whiteMesh = new THREE.Mesh(whiteGeom, new THREE.MeshStandardMaterial());
        // Ubicar la capa blanca en la parte superior de la extrusión:
        // la extrusión base tiene profundidad = extrudeSettings.depth; ponemos la blanca sobre la cara superior:
        whiteMesh.position.set(letra.posX * 1.1, 0, extrudeSettings.depth - whiteDepth + 0.1); // pequeño offset para evitar z-fighting
        whiteMesh.updateMatrix();
        whiteSurfaceMesh = whiteMesh;
      }

      // ---------- 5) actualizar prevUnionMesh = union(prevUnionMesh, baseOriginal) ----------
      // para que la próxima letra se recorte con la forma completa de todas las previas
      try {
        const toUnion = new THREE.Mesh(baseGeom.clone(), new THREE.MeshStandardMaterial());
        toUnion.position.set(letra.posX * 1.1, 0, 0);
        toUnion.updateMatrix();
        if (!prevUnionMesh) {
          prevUnionMesh = toUnion;
        } else {
          // union prevUnionMesh + toUnion
          try {
            const unioned = CSG.union(prevUnionMesh, toUnion);
            prevUnionMesh = unioned;
            prevUnionMesh.geometry.computeVertexNormals();
          } catch (err) {
            console.warn("CSG union falló:", err);
          }
        }
      } catch (err) {
        console.warn("Error al crear prevUnion:", err);
      }

      // ---------- 6) devolver geometrías y meshes listos para render ----------
      return {
        letra,
        coloredMesh: finalColoredMesh, // Mesh que ya tiene el recorte por prevUnion y hueco negro aplicado
        whiteMesh: whiteSurfaceMesh,   // Mesh fina blanca en la parte superior (si existe)
        // opcional: blackCutMesh si quieres representar el hueco con otro material (no necesario)
        blackCutMesh,
      };

    } catch (err) {
      console.error("Error extruyendo letra en memo", idx, err);
      return null;
    }
  });

  return results;
}, [letrasData, extrudeSettings, CURVE_SEGMENTS, whiteDepth, blackInsetDepth]);

// cleanup (dispose)
useEffect(() => {
  return () => {
    extrudedResultByLetter.forEach((r) => {
      if (!r) return;
      try { if (r.coloredMesh && r.coloredMesh.geometry) r.coloredMesh.geometry.dispose(); } catch {}
      try { if (r.whiteMesh && r.whiteMesh.geometry) r.whiteMesh.geometry.dispose(); } catch {}
      try { if (r.blackCutMesh && r.blackCutMesh.geometry) r.blackCutMesh.geometry.dispose(); } catch {}
    });
  };
}, [extrudedResultByLetter]);


const extrudedGeometries = useMemo(() => {
  return letrasData.map((letra) => {
    const shapes = letra.shapesContorno || [];
    if (!shapes || shapes.length === 0) return null;
    try {
      const g = new THREE.ExtrudeGeometry(shapes, extrudeSettings);
      // opcional: centrar cada geometría
      if (g.center) g.center();
      return g;
    } catch (err) {
      console.error("Error extruyendo letra:", letra.letra, err);
      return null;
    }
  });
}, [letrasData, extrudeSettings]);

// limpiar geometrías viejas al desmontar / cambiar
useEffect(() => {
  return () => {
    extrudedGeometries.forEach((g) => {
      try { if (g && g.dispose) g.dispose(); } catch (e) {}
    });
  };
}, [extrudedGeometries]);






  ////////////////////////////////

// ======= NUEVOS USESTATE =======
// ======== NUEVOS ESTADOS ========
const [usarColorGeneral, setUsarColorGeneral] = useState(false);
const [colorGeneral, setColorGeneral] = useState("#00aaff");

const [simularCintaLed, setSimularCintaLed] = useState(false);
const [colorLuz, setColorLuz] = useState("#ffffff");
const [colorLedAnimado, setColorLedAnimado] = useState("#ffffff");

//////////////////////////////////////////////////////////////////////////

// === ACTUALIZAR MATERIAL DE LETRAS ===
useEffect(() => {
    extrudedResultByLetter.forEach((res, i) => {
      if (!res || !res.coloredMesh) return;
      res.coloredMesh.material.color = new THREE.Color(coloresLetras[i]);
      res.coloredMesh.material.needsUpdate = true;
    });
  }, [coloresLetras, extrudedResultByLetter]);
  
  // === ACTUALIZAR MATERIAL DE CAPA BLANCA ===
  useEffect(() => {
    extrudedResultByLetter.forEach((res) => {
      if (!res || !res.whiteMesh) return;
      res.whiteMesh.material.color = new THREE.Color(colorLuz);
      res.whiteMesh.material.emissive = new THREE.Color(colorLuz);
      res.whiteMesh.material.emissiveIntensity = 0.8;
      res.whiteMesh.material.needsUpdate = true;
    });
  }, [colorLuz, extrudedResultByLetter]);

  // ======== EFECTO DE CINTA LED ========
  useEffect(() => {
    if (!simularCintaLed) return;
  
    const interval = setInterval(() => {
      const randomColor = "#" + Math.floor(Math.random() * 16777215).toString(16);
      setColorLuz(randomColor);
    }, 400); // cambia color cada 0.4 seg
  
    return () => clearInterval(interval);
  }, [simularCintaLed]);
  
/////////////////////////////////////////////////////////////////////////////////

// === NUEVOS ESTADOS ===
const [luzSuave, setLuzSuave] = useState(false);

// === MATERIAL DINÁMICO PARA VISTA 3D ===
const materialLuz = useMemo(() => {
  const mat = new THREE.MeshStandardMaterial({
    color: usarColorGeneral ? new THREE.Color(colorGeneral) : new THREE.Color("#ffffff"),
    emissive: usarColorGeneral ? new THREE.Color(colorGeneral) : new THREE.Color("#ffcc00"),
    emissiveIntensity: luzSuave ? 0.6 : 1.5,
    roughness: 0.4,
    metalness: 0.2,
  });
  return mat;
}, [usarColorGeneral, colorGeneral, luzSuave]);

// === COMPONENTE DE LUZ REALISTA ===
function LuzLED() {
  const ref = useRef();
  useEffect(() => {
    if (ref.current) {
      ref.current.color = new THREE.Color(colorGeneral);
      ref.current.intensity = luzSuave ? 2.5 : 4;
      ref.current.distance = luzSuave ? 120 : 60;
      ref.current.decay = luzSuave ? 0.8 : 2.0;
    }
  }, [colorGeneral, luzSuave]);
  return <pointLight ref={ref} position={[0, 0, 40]} />;
}

//////////////////////////////////////////////////////////////////////////////



//----------------------------------------------------------------------------------
if (!animacionSeleccionada) return null; // Muestra nada mientras se selecciona la animación
//--------------------------------------------------------------------------------------




  return (
    <div
  style={{
    width: "100%",
    height: "100%",
    background: "white",
    overflowX: "hidden",  // 🚫 elimina scroll horizontal
    overflowY: "auto",    // ✅ permite scroll vertical
  }}
>



{isLoading && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(180,180,180,0.6)', // plateado translúcido
      backdropFilter: 'blur(3px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
    }}
  >
    {/* Logo circular */}
    <div
      style={{
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: '#26e9f6',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 0 15px rgba(0,0,0,0.2)',
      }}
    >
      <div
        style={{
          width: '110px',
          height: '110px',
          borderRadius: '50%',
          overflow: 'hidden',
          backgroundColor: '#444',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={'images/dragonfondo.png'}
          alt="logo"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'dragonfondo.png';
          }}
        />
      </div>
    </div>

    {/* Barra de progreso */}
    <div
      style={{
        width: '200px',
        height: '12px',
        backgroundColor: '#ccc',
        borderRadius: '6px',
        marginTop: '20px',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${progress}%`,
          height: '100%',
          background: 'linear-gradient(90deg, #00e5ff, #00b3cc)',
          transition: 'width 0.2s ease',
        }}
      />
    </div>

    {/* Texto opcional */}
    <p
      style={{
        marginTop: '10px',
        color: '#222',
        fontWeight: 'bold',
        fontSize: '14px',
        letterSpacing: '1px',
      }}
    >
      Generando diseño 3D... {Math.round(progress)}%
    </p>
  </div>
)}


{/* 🔹 Contenedor general */}
<div
  style={{
    backgroundColor: '#000',
  }}
>
  {/* 🔸 Línea principal (imagen + nombre + título a la derecha) */}
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between', // 📍 separa el bloque izq. y el texto der.
      flexWrap: 'wrap', // 📱 para que en pantallas pequeñas se ajuste en varias líneas
      gap: '20px',
    }}
  >
    {/* 🔹 Bloque izquierdo: Imagen + texto “3DFyrion” */}
    <div
      style={{
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        minWidth: '250px',
      }}
    >
      {/* Imagen circular */}
      <div
        style={{
          width: '65px',
          height: '65px',
          borderRadius: '50%',
          backgroundColor: '#26e9f6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: '16px',
        }}
      >
        <div
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
            overflow: 'hidden',
            backgroundColor: '#444',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={'images/dragonfondo.png'}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'dragonfondo.png';
            }}
          />
        </div>
      </div>

      {/* Texto 3DFyrion */}
      <div>
        <span
          style={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: '20px',
            fontFamily: 'Madjoe',
          }}
        >
          3DFyrion
        </span>
        <br />
        <span
          style={{
            color: 'white',
            fontSize: '11px',
            fontFamily: 'Arial, sans-serif',
            opacity: 0.8,
          }}
        >
          Tecnología 3DFYRION
        </span>
      </div>
    </div>

    {/* 🔹 Texto derecho centrado */}
    <h2
      style={{
        color: 'white',
        margin: 0,
        textAlign: 'right',
        flex: 1, // 📍 hace que se centre y ocupe espacio disponible
        fontSize: '24px',
        marginRight:'20px'
      }}
    >
      💡 Vista 3D Lámpara Personalizada
    </h2>
  </div>

  {/* 🔹 Media query para móviles */}
  <style>{`
    @media (max-width: 600px) {
      h2 {
        font-size: 15px !important;
        text-align: center !important;
        width: 100% !important;
      }
      div[style*="display: flex"][style*="justify-content: space-between"] {
        justify-content: center !important;
      }
    }
  `}</style>
</div>



    {/* Animación de fondo */}
    <Lottie
      animationData={animacionSeleccionada} // Importa correctamente la animación JSON
      play
      loop
      style={{
        position: 'absolute', // Fija la animación al fondo de la ventana
        width: '300px',
        height: '300px',
        top: '0',
        left: '0',
        zIndex: 0, // Detrás del contenido
        pointerEvents: 'none', // Para que no interfiera con los clics
      }}
    />
  
      <div style={{ margin: "10px 0" }}>
  <label style={{ color: "black" }}>
  ✒️ Fuente:{" "}
    <select
  value={fuenteTemporal}
  onChange={(e) => setFuenteTemporal(e.target.value)}
>
  {nombresFuentes.map((f) => (
    <option key={f} value={f}>{f}</option>
  ))}
</select>

  </label>
</div>

<div className="flex flex-col items-center w-full mt-6 space-y-4">
  {/* Input de nombre */}
  <div className="flex flex-col items-center w-full">
    <label className="text-white text-lg mb-1">🧩 Nombre:</label>
    <input
      type="text"
      value={nombre}
      onChange={(e) => setNombre(e.target.value.toUpperCase())}
      className="text-center text-lg text-black rounded-lg px-3 py-2 w-64 focus:outline-none"
      placeholder="Escribe un nombre"
    />
  </div>

{/* 🔹 Botón Generar */}
<div className="flex flex-col items-center">
  <motion.button
    whileTap={{ scale: 0.93 }}
    animate={
      isModified
        ? { scale: [1, 1.12, 1] } // 💡 efecto respiración activo
        : { scale: 1 } // sin animación cuando está deshabilitado
    }
    transition={
      isModified
        ? { duration: 1.2, repeat: Infinity, ease: "easeInOut" }
        : {}
    }
    onClick={() => {
      if (!isModified) {
        setShowWarning(true);
        return;
      }
      setShowWarning(false);
      handleGenerate();
    }}
    disabled={!isModified}
    style={{
      backgroundColor: isModified ? "#71FC21" : "#B0B0B0", // 💚 activo / gris deshabilitado
      color: isModified ? "black" : "#555",
      fontWeight: "bold",
      padding: "14px 28px",
      fontSize: "16px",
      border: "none",
      borderRadius: "18px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
      cursor: isModified ? "pointer" : "not-allowed",
      transition: "all 0.3s ease",
      whiteSpace: "nowrap",
      width: "fit-content",
      marginTop:"20px",
      marginBottom:"5px",
      minWidth: "200px", // 🔹 mismo ancho aproximado del botón "Pedir mi lámpara"
      textAlign: "center",
    }}
    onMouseEnter={(e) => {
      if (isModified) e.currentTarget.style.filter = "brightness(1.15)";
    }}
    onMouseLeave={(e) => {
      if (isModified) e.currentTarget.style.filter = "brightness(1)";
    }}
  >
    ⚙️ Generar
  </motion.button>

  {/* 🔸 Mensaje de advertencia */}
  {showWarning && !isModified && (
    <p className="text-red-400 text-sm mt-2 animate-pulse">
      Haz un cambio primero
    </p>
  )}
</div>



</div>

      <div style={{ height: "100%", background: "#ffffff", borderRadius: 10 }}>
  <Canvas 
  frameloop="demand"
  gl={{ antialias: false, powerPreference: "low-power" }}
  dpr={[1, 1.5]} // limita pixelRatio, evita GPU alta carga
  camera={{ position: [0, 0, 200], fov: 45 }}>
    <ambientLight intensity={0.7} />
    <directionalLight position={[100, 100, 200]} intensity={1} />
    <OrbitControls />
    <ambientLight intensity={0.5} />
    <LuzLED />


    {extrudedResultByLetter.map((item, idx) => {
      if (!item) return null;

      // Para el mesh coloreado ya resultante (puede venir con caras no suavizadas)
      const colored = item.coloredMesh;
      const white = item.whiteMesh;

      return (
        <group key={idx}>
          {colored && (
            <primitive
              object={colored}
              // la geometría ya trae la posición internal si usamos .position en la mesh temporal
              // ajusta material:
              onUpdate={(mesh) => mesh.material = new THREE.MeshStandardMaterial({ color: letrasData[idx].bordeColor, metalness: 0.3, roughness: 0.5 })}
            />
          )}

          {white && (
            <primitive
              object={white}
              onUpdate={(mesh) => mesh.material = new THREE.MeshStandardMaterial({ color: "white", metalness: 0.0, roughness: 0.6 })}
            />
          )}

          {/* Si quieres mostrar el hueco negro como superficie (no obligatorio porque ya lo restamos),
              puedes renderizar blackCutMesh con material oscuro en la cara superior:
          {item.blackCutMesh && (
            <primitive object={item.blackCutMesh} onUpdate={(m)=> m.material = new THREE.MeshStandardMaterial({ color: "black" })} />
          )} */}
        </group>
      );
    })}

    <CameraZoomController zoom={1.8} />
  </Canvas>


  <div style={{ display: "flex", flexDirection: "column", background: "white" }}>
  <div>
    <h4 style={{ marginBottom: 5, textAlign: "center" }}>🎨 Colores por letra:</h4>

    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center", // 🔹 Centra horizontalmente
        gap: 10,                  // 🔹 Espacio entre cada letra/color
      }}
    >
      {letrasData.map((l, i) => (
        <div
          key={i}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 4,
            justifyContent: "center",
          }}
        >
          <span style={{ fontWeight: "bold" }}>{l.letra}</span>
          <input
            type="color"
            value={coloresLetras[i]}
            onChange={(e) => {
              const newColors = [...coloresLetras];
              newColors[i] = e.target.value;
              setColoresLetras(newColors);
            }}
            style={{
              width: 32,
              height: 32,
              cursor: "pointer",
              border: "none",
            }}
          />
        </div>
      ))}
    </div>
  </div>


  <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#20C7C7", // fondo naranja
    borderRadius: "16px",
    padding: "5px",
    marginTop: "40px",
    marginBottom:"350px" ,
    width: "100%",
    maxWidth: "300px", // puedes ajustar el ancho del contenedor
    marginLeft: "auto",
    marginRight: "auto",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)"
  }}
>
  <h3 style={{ color: "white", fontWeight: "bold", marginBottom: "10px" }}>
    🔆 SIMULACIÓN
  </h3>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "16px",
      width: "100%",
    }}
  >
    {/* Botón Simular Cinta LED */}
    <motion.button
      whileTap={{ scale: 0.93 }}
      className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-6 py-2 rounded-xl shadow-lg hover:shadow-xl hover:brightness-110 transition-all duration-300"
      onClick={() => setSimularCintaLed(!simularCintaLed)}
      style={{ flex: 1 }}
    >
      {simularCintaLed ? "〰️ Apagar Cinta LED" : "💡 Simular Cinta LED"}
    </motion.button>

    {/* Selector de color de luz */}
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
      <label style={{ color: "white", marginBottom: "6px", fontWeight: "bold" }}>
        Color de Luz
      </label>
      <input
        type="color"
        value={colorLuz}
        onChange={(e) => setColorLuz(e.target.value)}
        onMouseMove={(e) => setColorLuz(e.target.value)}
        style={{
          width: 50,
          height: 50,
          cursor: "pointer",
          border: "none",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
        }}
      />
    </div>
  </div>
</div>


</div>






</div>


{/* 🔹 Barra fija inferior */}
<div
  style={{
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    background: "#000000",
    borderTop: "2px solid #ddd",
    display: "grid",
    gridTemplateColumns: "1fr auto", // 🔹 Izquierda (botones + costo) | Derecha (total + botón)
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 20px",
    zIndex: 999,
    boxShadow: "0 -4px 12px rgba(0,0,0,0.2)",
    gap: "20px",
  }}
>
  {/* 🔸 Bloque izquierdo: Botones + Costo letra */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "25px",
      flexWrap: "wrap",
      marginLeft: "15px",
    }}
  >
    {/* 🔹 Botones Mini, Medio, Grande */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "15px",
        flexWrap: "wrap",
      }}
    >
      {[
        { label: "Mini ☺️", key: "Mini" },
        { label: "Mediano 🤗", key: "Mediano" },
        { label: "Grande 😉", key: "Grande" },
      ].map(({ label, key }) => (
        <div
          key={key}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 5,
          }}
        >
          <motion.button
            whileTap={{ scale: 0.93 }}
            style={{
              backgroundColor:
                tamanoSeleccionado === key ? "#71FC21" : "#3B82F6",
              color: tamanoSeleccionado === key ? "black" : "white",
              minWidth: "80px",
              height: "50px",
              fontWeight: "bold",
              fontSize: "15px",
              border: "none",
              borderRadius: "25px",
              boxShadow: "0 3px 8px rgba(0,0,0,0.3)",
              padding: "0 14px",
              cursor: "pointer",
              transition: "all 0.3s",
            }}
            onClick={() => seleccionarTamano(key)}
            onMouseEnter={(e) => {
              if (tamanoSeleccionado !== key)
                e.currentTarget.style.backgroundColor = "#2563EB";
            }}
            onMouseLeave={(e) => {
              if (tamanoSeleccionado !== key)
                e.currentTarget.style.backgroundColor = "#3B82F6";
            }}
          >
            {label}
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.93 }}
            style={{
              backgroundColor: "#000000",
              color: "white",
              width: "38px",
              height: "38px",
              borderRadius: "50%",
              fontSize: "18px",
              marginTop: "8px",
              border: "2px solid #555",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
            }}
            onClick={() => alert(`Información sobre tamaño ${label}`)}
          >
            ❓
          </motion.button>
        </div>
      ))}
    </div>

    {/* 🔹 Texto “Costo letra” */}
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        color: "white",
        marginLeft: "15px",
        minWidth: "90px",
      }}
    >
      <span style={{ fontSize: "20px", fontWeight: "bold" }}>Costo letra</span>
      <span style={{ fontSize: "22px", color: "#71FC21" }}>
        ${costoLetra.toLocaleString("es-CO")}
      </span>
    </div>
  </div>

  {/* 🔸 Bloque derecho: Total + Botón */}
  <div
    style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "20px",
    padding: "15px",

    /* 🚀 Mantener TOTAL + BOTÓN siempre juntitos */
    flexWrap: "nowrap",

    /* Evitar que el total se exprima */
    minWidth: "fit-content",
    }}
  >
{/* 🔹 Texto “Total (n Letras)” */}
<div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "white",
  }}
>
  <span style={{ fontSize: "20px", fontWeight: "bold" }}>
    Total {nLetras > 0 ? `(${nLetras} Letras)` : ""}
  </span>
  <span style={{ fontSize: "22px", color: "#71FC21" }}>
    ${total.toLocaleString("es-CO")}
  </span>
</div>


    {/* 🔹 Botón Pedir mi Lámpara */}
<motion.button
  className="btn-lampara"
  whileTap={{ scale: 0.93 }}
  animate={{ scale: [1, 1.12, 1] }}
  transition={{
    duration: 1.2,
    repeat: Infinity,
    ease: "easeInOut",
  }}
  onClick={() => alert("🛒 Pedir mi lámpara")}
  style={{
    backgroundColor: "#71FC21",
    color: "black",
    fontWeight: "bold",
    padding: "14px 28px",
    fontSize: "16px",
    border: "none",
    borderRadius: "18px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
    cursor: "pointer",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
  }}
>
  💡 Pedir mi Lámpara
</motion.button>

  </div>

  {/* 🔹 Media query inline con React */}
  <style>{`
    @media (max-width: 820px) {
      div[style*="grid-template-columns"] {
        grid-template-columns: 1fr !important;
        justify-items: center;
        text-align: center;
      }

      div[style*="justify-content: flex-start"] {
        justify-content: center !important;
      }

      div[style*="justify-content: flex-end"] {
        flex-direction: row !important;
        justify-content: center !important;
        flex-wrap: wrap !important;
      }

      button[style*="Pedir mi Lámpara"] {
        justify-self: center !important;
        width: 80%;
        font-size: 15px;
        margin-top: 10px;
      }
    }

    @media (max-width: 520px) {
      div[style*="justify-content: flex-end"] {
        flex-direction: column !important;
      }

      div[style*="justify-content: flex-start"] {
        flex-direction: column !important;
        align-items: center !important;
      }
    }
  `}</style>
</div>

<style>{`
  /* 📱 Tablets (menos de 820px) */
  @media (max-width: 820px) {

    /* Botones Mini/Mediano/Grande */
    button[style*="min-width"] {
      min-width: 60px !important;
      height: 40px !important;
      font-size: 12px !important;
      border-radius: 18px !important;
      padding: 0 8px !important;
    }

    /* Botón de ayuda ❓ */
    button[style*="border-radius: 50%"] {
      width: 30px !important;
      height: 30px !important;
      font-size: 14px !important;
      margin-top: 5px !important;
    }

    /* Textos */
    span[style*="font-size: 20px"],
    span[style*="font-size: 22px"] {
      font-size: 15px !important;
    }

    /* ⭐ Botón Pedir mi Lámpara */
    .btn-lampara {
      padding: 10px 18px !important;
      font-size: 14px !important;
      border-radius: 15px !important;
      transform: scale(0.9) !important; /* 🔥 reduce un poco más */
    }

    /* Ajustar gaps */
    div[style*="gap: 25px"] {
      gap: 12px !important;
    }
  }


/* 📱📱 Móviles (menos de 520px) */
@media (max-width: 520px) {

  /* 🔹 Botones Mini/Med/Grande más pequeños */
  button[style*="min-width"] {
    min-width: 46px !important;
    height: 32px !important;
    font-size: 10px !important;
    border-radius: 14px !important;
    padding: 0 4px !important;
  }

  /* 🔹 Botón de ayuda ❓ */
  button[style*="border-radius: 50%"] {
    width: 24px !important;
    height: 24px !important;
    font-size: 12px !important;
    margin-top: 3px !important;
  }

  /* 🔹 Reducimos el gap entre botones */
  div[style*="gap: 25px"],
  div[style*="gap: 20px"],
  div[style*="gap: 15px"] {
    gap: 6px !important;
  }

  /* 🔹 Ajustamos el texto “Costo letra” */
  span[style*="font-size: 20px"],
  span[style*="font-size: 22px"] {
    font-size: 12px !important;
  }

  /* 🔹 Forzar todo a mantenerse en una línea */
  div[style*="justify-content: flex-start"] {
    flex-wrap: nowrap !important;
    flex-direction: row !important;
    align-items: center !important;
  }

    /* ⭐ Botón Pedir mi Lámpara */
    .btn-lampara {
        padding: 8px 16px !important;
    font-size: 13px !important;
    border-radius: 12px !important;
    width: 85% !important;
    }

    div[style*="gap: 25px"],
    div[style*="gap: 20px"] {
      gap: 8px !important;
    }

    /* Centrado */
    div[style*="justify-content: flex-start"],
/* 🚀 En móviles, se siguen manteniendo juntos */
div[style*="justify-content: flex-end"] {
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  justify-content: center !important;
  gap: 12px !important;
}

  }
`}</style>




    </div>

    
  );
  
}








